import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getSalesSummaryWithDetails, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getProductTypes } from 'actions/EntityActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import { reportSalesSummaryDetailCrumb } from 'utils/breadcrumbInfo';
import PageHeader from 'screens/components/basic/PageHeader';
import DateCurrentDisplay from '../DateCurrentDisplay';

class SalesSummaryWithDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 30,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this)
        this.downloadReport = this.downloadReport.bind(this);
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `SalesSummaryDetailsBeginDate`);
        this.props.formInput(date, `SalesSummaryDetailsEndDate`);
        this.props.formInput(true, `SalesSummaryDetails_ShowGrossSales`);
        this.props.formInput(true, `SalesSummaryDetails_ShowNetSales`);
        this.props.formInput(true, `SalesSummaryDetails_ShowTax`);
        this.props.formInput(true, `SalesSummaryDetails_ShowDiscount`);
        this.props.formInput(true, `SalesSummaryDetails_ShowGrossProfit`);
        this.props.getProductTypes();
        if (localStorage.getItem("SalesSummaryDetailsToInclude")) {
            this.props.formInput(localStorage.getItem("SalesSummaryDetailsToInclude").split(","), "SalesSummaryDetailsDetailsToInclude")
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedDetailsToInclude != undefined && this.props.selectedDetailsToInclude != prevProps.selectedDetailsToInclude) {
            localStorage.setItem("SalesSummaryDetailsToInclude", this.props.selectedDetailsToInclude)
        }
    }

    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.salesSummaryDetails && newProps.salesSummaryDetails.data && newProps.salesSummaryDetails.data.length > 0 ? newProps.salesSummaryDetails.data.slice(-1)[0].totalRows : 0;
            this.setState({ totalRow: totalRow });
        }
    }

    cleanSearch = () => {
        this.props.clearFormInput(`SalesSummaryDetailsBeginDate`);
        this.props.clearFormInput(`SalesSummaryDetailsEndDate`);
        this.props.clearFormInput(`SalesSummaryDetailsBranchOption`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        let branchIds = this.props.branch || this.props.loggedBranch;
        let isCannabis = this.props.selectIsCannabis || 2;
        let categoryId = this.props.selectCategoryId || 0;
        let orderType = this.props.selectOrderType || 0;
        let onlineOrderType = this.props.selectOnlineOrderType || 0;
        let dateGroupBy = this.props.selectGroupBy || "Day";
        let selectedDetailsToInclude = this.props.selectedDetailsToInclude || [];

        const details = ["SalesProfit", "Tax", "Cannabis", "Giftcard", "OrderType"];
        const detailsToInclude = details.filter(item => selectedDetailsToInclude.map(item => item.value).includes(item));

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/salesSummaryWithDetails?beginDate=${beginDate}&endDate=${endDate}&branchIds=${branchIds}&isCannabis=${isCannabis}&categoryId=${categoryId}&orderType=${orderType}&onlineOrderType=${onlineOrderType}&dateGroupBy=${dateGroupBy}&detailsToInclude=${detailsToInclude}`, "salesSummaryWithDetails");
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        let branchIds = this.props.branch || this.props.loggedBranch;   //single branch for now. backend available for multi branch select
        let isCannabis = this.props.selectIsCannabis || 2;
        let categoryId = this.props.selectCategoryId || 0;
        let orderType = this.props.selectOrderType || 0;
        let onlineOrderType = this.props.selectOnlineOrderType || 0;
        let dateGroupBy = this.props.selectGroupBy || "Day";
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        this.props.getSalesSummaryWithDetails({ beginDate, endDate, branchIds, isCannabis, categoryId, orderType, onlineOrderType, dateGroupBy, pageNumber, pageSize });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }


    render() {

        return (
            <Grid headerContent={reportSalesSummaryDetailCrumb}>
                <PageHeader title={LOOKUP.report.SalesSummaryDetails.text} description={LOOKUP.report.SalesSummaryDetails.description} />
                <Header
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    categoryOptions={this.props.categoryOptions}
                    isCannabisOptions={this.props.isCannabisOptions}
                    groupByOptions={this.props.groupByOptions}
                    orderTypesOptions={this.props.orderTypesOptions}
                    onlineOrderTypesOptions={this.props.onlineOrderTypesOptions}
                    detailsToIncludeOptions={this.props.detailsToIncludeOptions}
                    isCannabis={this.props.selectIsCannabis}
                    orderType={this.props.selectOrderType}
                />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                <div id="patient-list-table">
                    {
                        this.state.showBody && this.props.salesSummaryDetails &&
                        <CardSimple>
                            <Body
                                salesSummaryDetails={this.props.salesSummaryDetails}
                                beginDate={this.props.beginDate}
                                endDate={this.props.endDate}
                                selectedDetailsToInclude={this.props.selectedDetailsToInclude}
                                detailsToIncludeOptions={this.props.detailsToIncludeOptions}
                            />
                            <Pagination
                                length={this.state.totalRow}
                                itemsPerPage={this.state.itemsPerPage}
                                activePage={this.state.activePage}
                                onPageChange={this.changePage}
                            />
                        </CardSimple>
                    }
                </div>
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    let categories = [];
    const cat = state.entity.productTypesList && state.entity.productTypesList.length > 0 ? state.entity.productTypesList[0].categories : [];
    cat.map(item => {
        categories.push({
            text: item.name,
            value: item.id.toString(),
            isCannabis: item.isCannabis
        });
    });

    categories.sort((a, b) => {
        if (a.text < b.text)
            return -1;
        if (a.text > b.text)
            return 1;
        return 0;
    });

    categories.unshift({ text: "All", value: "0", isCannabis: false }, { text: "All", value: "0", isCannabis: true });

    let isCannabis = [
        { text: "All", value: "2" },
        { text: "Cannabis", value: "1" },
        { text: "Non-Cannabis", value: "0" }
    ];

    let groupBy =
        [
            { text: "Daily", value: "Day" },
            { text: "Weekly", value: "Week" },
            { text: "Monthly", value: "Month" },
            { text: "Yearly", value: "Year" }
        ];
    let orderTypes =
        [
            { text: "All", value: "0" },
            { text: "Instore", value: "1" },
            { text: "Online", value: "2" },
        ];
    let onlineOrderTypes =
        [
            { text: "All", value: "5" },
            { text: "Paid Online & Store Pickup", value: "4" },
            { text: "Paid Online & Delivery", value: "3" },
            { text: "Paid Instore & Store Pickup", value: "2" },
            { text: "Express Checkout", value: "1" }
        ];
    let details =
        [
            { text: "Sales and Profit", value: "SalesProfit" },
            { text: "Tax Breakdown", value: "Tax" },
            { text: "Cannabis/Non-Cannabis Breakdown", value: "Cannabis" },
            { text: "Gift Cards", value: "Giftcard" },
            { text: "Order Type Breakdown", value: "OrderType" },
            { text: "Charts - Sales", value: "ChartsSales" },
            { text: "Charts - Transaction Amount", value: "ChartTransAmount" },
            { text: "Charts - Transaction Count", value: "ChartsTransCount" }
        ]
    return {
        branchOptions: branchOptions,
        salesSummaryDetails: state.reports.salesSummaryDetails,
        loggedBranch: state.common.branchId,
        beginDate: state.form.SalesSummaryDetailsBeginDate,
        endDate: state.form.SalesSummaryDetailsEndDate,
        branch: state.form.SalesSummaryDetailsBranchOption,
        selectIsCannabis: state.form.SalesSummaryDetailsIsCannabis,
        selectCategoryId: state.form.SalesSummaryDetailsCategory,
        selectGroupBy: state.form.SalesSummaryDetailsGroupBy,
        selectOrderType: state.form.SalesSummaryDetailsOrderType,
        selectOnlineOrderType: state.form.SalesSummaryDetailsOnlineOrderType,
        selectedDetailsToInclude: state.form.SalesSummaryDetailsDetailsToInclude,

        isCannabisOptions: isCannabis,
        categoryOptions: categories,
        groupByOptions: groupBy,
        orderTypesOptions: orderTypes,
        onlineOrderTypesOptions: onlineOrderTypes,
        detailsToIncludeOptions: details
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getSalesSummaryWithDetails: model => dispatch(getSalesSummaryWithDetails(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getProductTypes: () => dispatch(getProductTypes()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(SalesSummaryWithDetails));